import { formatToSqlDateTime } from '@apply/ui';
import { addMonths } from '../../../../../../../../../../common/functions/addMonths';
import { SetupForm, SetupLoanContext } from '../constants/setupForm';
import { parseSetupDate } from './parseSetupDate';

/**
 * Maturity Date = Note Date + Initial Term (months), recalculated whenever either changes (not for sub notes).
 * Returns the new Maturity Date, or nothing when it can't/shouldn't be calculated.
 */
export const calculateMaturityDate = (form: SetupForm, context: SetupLoanContext): string | undefined => {
    const noteDate = parseSetupDate(form.noteDate);
    if (context.isSubNote || !noteDate || !form.initialTermMonths) {
        return undefined;
    }
    return formatToSqlDateTime(addMonths(noteDate, form.initialTermMonths));
};
